import api from '../../../../../configurations/service';
import * as types from './mutation-types';

export const setIbsRegimeCodesCollection = async (context) => {
  const { data } = await api(2).post('fiscal.get-ibs-regime-codes');

  context.commit(types.SET_CLASS_TRIB_IBS_CBS_COLLECTION, data.classTribIBSCBS);
  context.commit(types.SET_CST_IBS_CBS_COLLECTION, data.CSTIBSCBS);
  context.commit(types.SET_CLASS_TRIB_IS_COLLECTION, data.classTribIS);
  context.commit(types.SET_CST_IS_COLLECTION, data.CSTIS);
  context.commit(types.SET_COD_CRED_PRES_COLLECTION, data.credPres);
};

export const getIbsTaxRegimeAliquots = async (context, params) => {
  const { data } = await api().post('fiscal.get-ibs-tax-regime-aliquots', params);

  return data;
};
